import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import brand from '../../assets/logos/brand.png';
import nike from '../../assets/logos/nike.png';
import { brandModal } from '../../features/modal/modal.slice';
import { getAllPosts } from '../../features/post/post.slice';
import AddPost from './pages/addpost';
import Analytics from './pages/analytics';
import APIPage from './pages/api';
import Channels from './pages/channels';
import CommentPage from './pages/comments/CommentPage';
import Home from './pages/home';
import Plans from './pages/plans';
import Settings from './pages/settings';

const MainPage = ({ selectedPage, setSelectedPage }) => {
  function pageHandler(page) {
    switch (page) {
      case 'Home':
        return <Home setSelectedPage={setSelectedPage} />;
      case 'Plan':
        return <Plans />;
      case 'Comments':
        return <CommentPage />;
      case 'Channels':
        return <Channels />;
      case 'Settings':
        return <Settings />;
      case 'Analytics':
        return <Analytics />;
      case 'API':
        return <APIPage />;
      case 'AddPost':
        return <AddPost />;
    }
  }
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllPosts());
  }, []);
  return (
    <>
      {selectedPage.title !== 'API' ? (
        <div className="md:flex space-x-5 py-3 px-8 hidden">
          <img className="h-12 w-12" src={brand} alt="brand logo" />
          <img className="h-12 w-12" src={nike} alt="Nike logo" />
          <div
            className="bg-neutral-300 h-12 w-12 rounded-full flex justify-center items-center cursor-pointer hover:bg-neutral-400 transition-colors duration-100"
            onClick={() => dispatch(brandModal(true))}
          >
            <i className="fa-solid fa-plus text-2xl"></i>
          </div>
        </div>
      ) : (
        <div className="py-9"></div>
      )}
      {pageHandler(selectedPage.title)}
    </>
  );
};

export default MainPage;
